import React from "react";
import Grid from "../Grid";
import styled, { css, useTheme } from "styled-components";
import Tooltippy from "../Tooltippy";
import { useMediaQuery } from "../../hooks/useMediaQuery";

const ToggleStyles = styled.div`
  ${({ theme }) => css`
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.5rem 0;
      gap: 22px;

      label {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        font-weight: 600;
        font-size: 1.25rem;
      }

      .switch-wrapper {
        position: relative;
        display: inline-block;
        width: 5rem;
        height: 2.75rem;

        input {
          position: absolute;
          inset: 0;
          opacity: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
          z-index: 1;

          &:disabled {
            cursor: not-allowed;
          }
        }

        .slider {
          position: absolute;
          inset: 0;
          background-color: ${theme.colors.darkGrey};
          border-radius: 34px;
          transition: 0.4s;

          &::before {
            position: absolute;
            content: "";
            height: 2rem;
            width: 2rem;
            left: 0.375rem;
            bottom: 0.375rem;
            background-color: white;
            border-radius: 50%;
            transition: 0.4s;
          }
        }

        input:disabled + .slider {
          background-color: #AEAEAC;
        }

        input:checked + .slider {
          background-color: ${theme.colors.primary};
        }

        input:checked + .slider::before {
          transform: translateX(2.25rem);
        }
      }
    }
  `}
`;
export const Toggle = ({
  label,
  name,
  value,
  defaultValue,
  onChange,
  show,
  disabled,
  tooltip,
}) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);

  if (!show) return null;

  return (
    <ToggleStyles>
      <div className="wrapper">
        {isLargeScreen ? (
          <Tooltippy
            text={<div dangerouslySetInnerHTML={{ __html: tooltip }} />}
            width="20px"
            height="20px"
          >
            <label htmlFor={name}>{label}</label>
          </Tooltippy>
        ) : (
          <label htmlFor={name}>
            {label}
          </label>
        )}
        <div className="switch-wrapper">
          <input
            type="checkbox"
            id={name}
            name={name}
            checked={value === "true"}
            onChange={(e) => {
              onChange({
                target: {
                  name,
                  value: e.target.checked ? "true" : defaultValue,
                },
              })
            }
            }
            disabled={disabled}
          />
          <span className="slider" />
        </div>
      </div>
      {!isLargeScreen && <div dangerouslySetInnerHTML={{ __html: tooltip }} className="mobile-tooltip"/>}
    </ToggleStyles>
  );
};
